import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';

const AutoSaveIndicator = ({ 
  isAutoSaving = false, 
  lastAutoSave = null, 
  autoSaveEnabled = true,
  autoSaveInterval = 30 
}) => {
  const [timeUntilNextSave, setTimeUntilNextSave] = useState(autoSaveInterval);

  useEffect(() => {
    if (!autoSaveEnabled || isAutoSaving) return;

    const interval = setInterval(() => {
      setTimeUntilNextSave(prev => {
        if (prev <= 1) {
          return autoSaveInterval;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [autoSaveEnabled, isAutoSaving, autoSaveInterval]);

  const formatLastSave = (timestamp) => {
    if (!timestamp) return '';
    const now = new Date();
    const saved = new Date(timestamp);
    const diffInSeconds = Math.floor((now - saved) / 1000);
    
    if (diffInSeconds < 60) return `${diffInSeconds}s ago`;
    
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    return `${diffInHours}h ago`;
  };

  if (!autoSaveEnabled) {
    return (
      <div className="flex items-center space-x-2 text-muted-foreground">
        <Icon name="CloudOff" size={14} />
        <span className="text-xs">Auto-save disabled</span>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      {isAutoSaving ? (
        <>
          <Icon name="Loader2" size={14} className="animate-spin text-accent" />
          <span className="text-xs text-accent">Auto-saving...</span>
        </>
      ) : lastAutoSave ? (
        <>
          <Icon name="Cloud" size={14} className="text-success" />
          <span className="text-xs text-success">
            Saved {formatLastSave(lastAutoSave)}
          </span>
          <span className="text-xs text-muted-foreground">
            • Next save in {timeUntilNextSave}s
          </span>
        </>
      ) : (
        <>
          <Icon name="Cloud" size={14} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">
            Auto-save in {timeUntilNextSave}s
          </span>
        </>
      )}
    </div>
  );
};

export default AutoSaveIndicator;